module.exports = new __parcel__URL__("icon-space-overview-empty.106059f9.svg").toString();